document.addEventListener("DOMContentLoaded", function() {
    var size_select = document.querySelectorAll(".bj-variant-size-container .bj-variant-size-select-options");
    var bj_drawers = document.querySelectorAll(".bj-drawer");
    var bj_close_btns = document.querySelectorAll(".bj-drawer .bj-drawer-btn-close");
    var bj_drawer_back = document.querySelectorAll(".bj-drawer .bj-drawer-overlay");
    var info_icon_btns = document.querySelectorAll(".product-card__info-icon");

    size_select.forEach(select => {
        select.addEventListener("change", function() {
            this.closest(".bj-variant-size-container").querySelector("#" + this.value).click();
            if(this.value != "default") {
                if(this.nextElementSibling) {
                    this.nextElementSibling.style.display = "none";
                }
            }
        });
    });


    bj_close_btns.forEach(btn => {
        btn.addEventListener("click", function() {
            this.closest(".bj-drawer").classList.remove("active");
        });
    });

    bj_drawer_back.forEach(btn => {
        btn.addEventListener("click", function() {
            this.closest(".bj-drawer").classList.remove("active");
        });
    });

    // Handle info icon clicks for "Did You Know" popups
    info_icon_btns.forEach(btn => {
        btn.addEventListener("click", function(e) {
            e.preventDefault();
            e.stopPropagation();
            const popupId = this.getAttribute("onclick").match(/'([^']+)'/)[1];
            openPopup(popupId);
        });
    });
  


    if(document.querySelectorAll(".bj-product media-carousel .product-gallery__media")) {
        var media_items = document.querySelectorAll(".bj-product media-carousel .product-gallery__media");

        media_items.forEach(media => {
            media.addEventListener("click", function() {
                media_items.forEach(me => {
                    me.classList.remove("m-active");
                });
                media.classList.add("m-active");

                window.scrollTo({top: 0, behavior: 'smooth'});

            });
        });
    }

    
    if(document.querySelectorAll(".bj-main-product media-carousel  .product-gallery__media")) {
        var p_media_items = document.querySelectorAll(".bj-main-product media-carousel  .product-gallery__media");

        p_media_items.forEach(media => {
            media.addEventListener("click", function() {
                p_media_items.forEach(me => {
                    me.classList.remove("m-active");
                });
                media.classList.add("m-active");

                window.scrollTo({top: 0, behavior: 'smooth'});

            });
        });
    }
  



    const legacyDrawer = document.querySelector(".bj-mobile-drawer-menu");
    const legacyHeader = document.querySelector("header");
    if (legacyDrawer && legacyHeader) {
        window.addEventListener("scroll", () => {
            legacyDrawer.style.top = (legacyHeader.getBoundingClientRect().top + legacyHeader.clientHeight) + "px";
        }, { passive: true });
    }

    if(document.querySelectorAll(".bj-pdp-usps")) {
        const items = document.querySelectorAll(".bj-pdp-usps .pdp-usps__item");
        items.forEach(item => {
            item.addEventListener("click", function() {
                const data_id = this.getAttribute("data-id");
                console.log("dfsdf", document.querySelector(".bj-drawer[data-drawer-id='Why-shop-with-us']").querySelectorAll(".bj-accordion-item")[data_id].querySelector("input").checked);
                const acc_items = document.querySelector(".bj-drawer[data-drawer-id='Why-shop-with-us']").querySelectorAll(".bj-accordion-item");
                
                acc_items.forEach(acc => {
                    if(acc.querySelector("input").checked == true) {
                        acc.querySelector("label").click();
                    }
                });
                document.querySelector(".bj-drawer[data-drawer-id='Why-shop-with-us']").classList.add("active");

                document.querySelector(".bj-drawer[data-drawer-id='Why-shop-with-us']").querySelectorAll(".bj-accordion-item")[data_id].querySelector("label").click();
            });
        });
    }

    const submitButton = document.querySelector(".bj-product .product-form__buttons .product-form__submit");
    if (submitButton) {
        submitButton.addEventListener("click", function (event) {
            const productInfo = this.closest(".product-info");
            if (productInfo) {
                const fieldsets = productInfo.querySelectorAll("variant-radios fieldset");
            const inputs = productInfo.querySelectorAll("variant-radios fieldset input");
            let selectedCount = 0;

            // Check each input for selection
            inputs.forEach(input => {
                if (input.checked) {
                    selectedCount++;
                }
            });

            if (selectedCount < fieldsets.length) {
                event.preventDefault();
                console.log("Not all options selected. Preventing form submission.");

                // Show indicators for unselected options
                fieldsets.forEach(item => {
                    const indicator = item.querySelector(".option-select-indicator");
                    if (indicator) {
                        if (!item.querySelector("input:checked")) {
                            indicator.style.display = "block";
                        } else {
                            indicator.style.display = "none";
                        }
                    }
                });
            } else {
                // Hide all indicators if all options are selected
                fieldsets.forEach(item => {
                    const indicator = item.querySelector(".option-select-indicator");
                    if (indicator) {
                        indicator.style.display = "none";
                    }
                });
            }
            }

            

            // Handle optional indicator for `.bj-option-select-indicator`
            // const optionIndicator = document.querySelector(".bj-product .bj-option-select-indicator");
            // if (optionIndicator) {
                // optionIndicator.style.display = "block";
            // }
        });
    }

    

    

    if(document.querySelector(".bj-variant-size-container .bj-btn-variant-size-guide")) {
        const size_btn = document.querySelector(".bj-variant-size-container .bj-btn-variant-size-guide");
        size_btn.addEventListener("click", function() {
            document.querySelector(".bj-drawer[data-drawer-id='size-chart']").classList.add("active");
        });
    }

    var var_input = document.querySelector(".bj-product .product-form form input.product-variant-id");

    if(var_input){
        var_input.addEventListener("change", function() {
        var product_images = document.querySelectorAll(".bj-product media-carousel .product-gallery__media");
        var item_index = -1;
            product_images.forEach((item, index) => {
                item.classList.remove("m-active");
                if(item.getAttribute("data-variant-id") == this.value) {
                    item_index = index;
                }
            });
            console.log("change variant media", document.querySelector(".bj-product media-carousel .product-gallery__media[data-variant-id='" + this.value + "']"));
            if(document.querySelector(".bj-product media-carousel .product-gallery__media[data-variant-id='" + this.value + "']")) {
                document.querySelector(".bj-product media-carousel .product-gallery__media[data-variant-id='" + this.value + "']").classList.add("m-active");
            }

            console.log("item index", item_index);

            if(item_index != -1) {
                var dots = document.querySelectorAll(".bj-product .page-dots button");
                dots[item_index].click();
            }
        });
    }

    var gallery_items = document.querySelectorAll(".bj-product media-carousel .product-gallery__media");
    gallery_items.forEach((item, index) => {
        item.addEventListener("click", function() {
            this.querySelector("button").click();
        });
    });

// Variant selector and on change event 

    document.querySelectorAll('.flex-accordian').forEach(selector => {
        selector.addEventListener('click', function(e) {
            const accordion = this.closest('.accordian-custon');
            accordion.classList.toggle('active');
            e.stopPropagation();
        });
    });
  
    document.addEventListener('click', function(e) {
        if (!e.target.closest('.accordian-custon')) {
            document.querySelectorAll('.accordian-custon').forEach(accordion => {
            accordion.classList.remove('active');
            });
        }
    });

    function handleVariantSelection(li, triggerRestockButton, appEvent) {
        console.log('handleVariantSelection called with:', {
            li: li,
            triggerRestockButton: triggerRestockButton,
            appEvent: appEvent
        });

        const select = li.closest('.main-select-variant-option')?.querySelector('.bj-variant-size-select-options');
        if (!select) {
            console.log('Select element not found');
            return;
        }

        const liValue = li.getAttribute('value');
        if (!liValue) {
            console.log('No value attribute found on li element');
            return;
        }
        
        console.log('Setting select value to:', liValue);
        select.value = liValue;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        const optionIndicator = document.querySelector(".bj-option-select-indicator.option-select-indicator");
        if (optionIndicator) {
            optionIndicator.style.display = "none";
        }
        
        const customSelectedValue = li.closest('.accordian-custon')?.querySelector('.custom-selected-value');
        if (customSelectedValue) {
            customSelectedValue.textContent = li.textContent.trim();
        }
        
        const accordion = li.closest('.accordian-custon');
        if (accordion) {
            accordion.classList.remove('active');
        }
        
        if (!appEvent) {
            if (triggerRestockButton) {
                const restockButton = document.querySelector('.restock-rocket-button-container .restock-rocket-button-cover');
                if (restockButton) {
                    console.log('Clicking restock button');
                    setTimeout(() => restockButton.click(), 100);
                } else {
                    console.log('Restock button not found');
                }
            } else {
                const enquireButton = document.querySelector('.product-form__buttons button[data-enquire-form]');
                if (enquireButton) {
                    console.log('Clicking enquire button');
                    setTimeout(() => enquireButton.click(), 100);
                } else {
                    console.log('Enquire button not found');
                }
            }
        }
    }

    document.querySelectorAll('.custom-select-variant li').forEach(li => {
        const variantValue = li.querySelector('.variant-value');
        const emailIcon = li.querySelector('.email-icon');
        const defaultVariant = li.querySelector('.default-variant-value');
        
        if (variantValue) {
            variantValue.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                handleVariantSelection(li, false, false);
            });
        } 
        if (emailIcon) {
            emailIcon.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                handleVariantSelection(li, false, false);
            });
        } 
        if(defaultVariant){
            li.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                handleVariantSelection(li, false, true);
            });
        }
    });

});

document.addEventListener("DOMContentLoaded", function () {
    function updatePrevButton() {
        const prevButton = document.querySelector('.pagination__item[rel="prev"]');
        if (prevButton) {
            let url = new URL(prevButton.href);
            if (url.searchParams.get("page") === "1") {
                prevButton.href = url.pathname; 
            }
        }
    }

    function cleanURL() {
        let currentUrl = new URL(window.location.href);
        if (currentUrl.searchParams.get("page") === "1") {
            currentUrl.searchParams.delete("page"); 
            window.history.replaceState({}, "", currentUrl.pathname); 
        }
    }

    updatePrevButton();
    cleanURL();

    document.addEventListener("click", function (event) {
        const target = event.target.closest('.pagination__item');
        if (target) {
            setTimeout(() => {
                updatePrevButton();
                cleanURL();
            }, 100); 
        }
    });
   
    window.addEventListener("popstate", function () {
        updatePrevButton();
        cleanURL();
    });
});

// Simple popup functions for "Did You Know"
window.openPopup = function(popupId) {
    // Remove any existing popup first
    const existingPopup = document.querySelector('.did-you-know-popup');
    if (existingPopup) {
        existingPopup.remove();
    }
    
    // Get the product info
    const productCard = document.querySelector(`[onclick*="${popupId}"]`).closest('.product-card');
    const productTitle = productCard.querySelector('.product-card__title').textContent.trim();
    
    // Try to get content from mobile-friendly hidden div first, fallback to visible div
    let didYouKnowContent = '';
    const mobileContent = productCard.querySelector('.dyk_cover-mobile p');
    const visibleContent = productCard.querySelector('.dyk_cover p');
    
    if (mobileContent && mobileContent.textContent.trim()) {
        didYouKnowContent = mobileContent.textContent.trim();
    } else if (visibleContent && visibleContent.textContent.trim()) {
        didYouKnowContent = visibleContent.textContent.trim();
    }
    
    // Create popup HTML with animation classes
    const popupHTML = `
        <div class="did-you-know-popup" style="
            position: fixed;
            top: 0;
            left: 0;
            width: 100vw;
            height: 100vh;
            background: rgba(0, 0, 0, 0);
            z-index: 99999;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: background-color 0.3s ease;
        ">
            <div class="popup-content" style="
                background: white;
                border-radius: 12px;
                box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
                width: 90%;
                max-width: 500px;
                max-height: 80vh;
                overflow-y: auto;
                position: relative;
                transform: scale(0.7);
                opacity: 0;
                transition: all 0.3s ease;
            ">
                <div class="popup-header" style="
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 10px 20px 5px 20px;
                    border-bottom: 1px solid #eee;
                ">
                    <h3 style="margin: 0; font-size: 20px; font-weight: 600; color: #333; font-family: 'Cardo', serif;">
                        Did you know...
                    </h3>
                                         <button type="button" class="popup-close" style="
                         background: none;
                         border: none;
                         cursor: pointer;
                         padding: 8px;
                         border-radius: 50%;
                         transition: all 0.2s ease;
                         display: flex;
                         align-items: center;
                         justify-content: center;
                     " onmouseover="this.style.backgroundColor='rgba(0,0,0,0.1)'" onmouseout="this.style.backgroundColor='transparent'">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M18 6L6 18M6 6L18 18" stroke="#333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </button>
                </div>
                <div class="popup-body" style="
                    padding: 20px;
                    line-height: 1.6;
                    max-height: 60vh;
                    overflow-y: auto;
                ">
                    <p style="margin: 0; font-size: 16px; color: #333;">
                        ${didYouKnowContent}
                    </p>
                </div>
            </div>
        </div>
    `;
    
    // Append to body
    document.body.insertAdjacentHTML('beforeend', popupHTML);
    document.body.style.overflow = 'hidden';
    
    // Trigger entrance animation after a brief delay
    setTimeout(() => {
        const popup = document.querySelector('.did-you-know-popup');
        const popupContent = popup.querySelector('.popup-content');
        const closeButton = popup.querySelector('.popup-close');
        
        // Add event listener to close button
        closeButton.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            closePopup();
        });
        
        // Animate overlay background
        popup.style.background = 'rgba(0, 0, 0, 0.6)';
        
        // Animate content
        popupContent.style.transform = 'scale(1)';
        popupContent.style.opacity = '1';
    }, 10);
}

console.log('Defining closePopup function...');
window.closePopup = function() {
    const popup = document.querySelector('.did-you-know-popup');
    if (popup) {
        const popupContent = popup.querySelector('.popup-content');
        
        // Start exit animation
        popup.style.background = 'rgba(0, 0, 0, 0)';
        popupContent.style.transform = 'scale(0.7)';
        popupContent.style.opacity = '0';
        
        // Remove popup after animation completes
        setTimeout(() => {
            popup.remove();
            document.body.style.overflow = '';
        }, 300);
    }
}

// Close popup when clicking overlay
document.addEventListener('click', function(e) {
    // Only close if clicking the overlay background, not the content
    if (e.target.classList.contains('did-you-know-popup') && !e.target.closest('.popup-content')) {
        closePopup();
    }
});

// Close popup with Escape key
document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
        const activePopup = document.querySelector('.did-you-know-popup');
        if (activePopup) {
            closePopup();
        }
    }
});

// Debug: Check if functions are available
console.log('Functions available:', {
    openPopup: typeof window.openPopup,
    closePopup: typeof window.closePopup
});

// Add cky-banner-element class to "Change Cookie Preferences" link in Information column
function updateCookiePreferencesLink() {
    const footer = document.querySelector('footer');
    if (!footer) return false;
    
    const linksToUpdate = [];
    
    // Find desktop structure (data-colname="Information")
    const informationColumn = footer.querySelector('[data-colname="Information"]');
    if (informationColumn) {
        const lastLi = informationColumn.querySelector('li:last-child');
        if (lastLi) {
            const desktopLink = Array.from(lastLi.querySelectorAll('a')).find(anchor => 
                anchor.textContent.trim().includes("Cookie Preferences")
            );
            if (desktopLink && !desktopLink.classList.contains('cky-banner-element')) {
                linksToUpdate.push(desktopLink);
            }
        }
    }
    
    // Find mobile structure (data-accordion-item)
    const accordionItems = footer.querySelectorAll('[data-accordion-item]');
    let targetAccordionItem = null;
    
    // Look for accordion item with "Information" title
    accordionItems.forEach(item => {
        const titleLabel = item.querySelector('.accordion-item-title-label');
        if (titleLabel && titleLabel.textContent.trim().includes("Information")) {
            targetAccordionItem = item;
        }
    });
    
    // If not found, use the last accordion item as fallback
    if (!targetAccordionItem && accordionItems.length > 0) {
        targetAccordionItem = accordionItems[accordionItems.length - 1];
    }
    
    if (targetAccordionItem) {
        // Find ul inside the accordion content (nested in data-accordion-content)
        const accordionContent = targetAccordionItem.querySelector('[data-accordion-content]');
        const ul = accordionContent ? accordionContent.querySelector('ul') : targetAccordionItem.querySelector('ul');
        if (ul) {
            const lastLi = ul.querySelector('li:last-child');
            if (lastLi) {
                const mobileLink = Array.from(lastLi.querySelectorAll('a')).find(anchor => 
                    anchor.textContent.trim().includes("Cookie Preferences")
                );
                if (mobileLink && !mobileLink.classList.contains('cky-banner-element')) {
                    linksToUpdate.push(mobileLink);
                }
            }
        }
    }
    
    // Apply changes to all found links
    if (linksToUpdate.length > 0) {
        linksToUpdate.forEach(link => {
            // Add the class
            link.classList.add('cky-banner-element');
            
            // Change href from # to javascript:void(0) to prevent jumping to top
            const currentHref = link.getAttribute('href');
            if (currentHref === '#' || currentHref === '' || !currentHref) {
                link.setAttribute('href', 'javascript:void(0)');
            }
        });
        //console.log('Cookie Preferences links found and updated:', linksToUpdate.length, linksToUpdate);
        return true;
    } else {
        // Last resort: search all anchors in footer for "Cookie Preferences" that's not already processed
        const allAnchors = footer.querySelectorAll('a');
        const fallbackLink = Array.from(allAnchors).find(anchor => {
            const text = anchor.textContent.trim();
            return (text === "Cookie Preferences" || text.includes("Cookie Preferences")) && 
                   !anchor.classList.contains('cky-banner-element');
        });
        
        if (fallbackLink) {
            fallbackLink.classList.add('cky-banner-element');
            const currentHref = fallbackLink.getAttribute('href');
            if (currentHref === '#' || currentHref === '' || !currentHref) {
                fallbackLink.setAttribute('href', 'javascript:void(0)');
            }
            //console.log('Cookie Preferences link found via fallback and updated:', fallbackLink);
            return true;
        } else {
            //console.log('Cookie Preferences link not found in footer');
            return false;
        }
    }
}

// Run on DOMContentLoaded
document.addEventListener("DOMContentLoaded", function() {
    updateCookiePreferencesLink();
});

// Also run on window load as fallback (in case content loads dynamically)
window.addEventListener("load", function() {
    setTimeout(updateCookiePreferencesLink, 100);
});



